"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ViewPort = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var ViewPort = exports.ViewPort = /*#__PURE__*/function (ViewPort) {
  ViewPort[ViewPort["NOT_DEFINED"] = 0] = "NOT_DEFINED";
  ViewPort["XS"] = "XS";
  ViewPort["SM"] = "SM";
  ViewPort["MD"] = "MD";
  ViewPort["LG"] = "LG";
  return ViewPort;
}({});
var ViewPortHelpers = /*#__PURE__*/function () {
  function ViewPortHelpers() {
    (0, _classCallCheck2.default)(this, ViewPortHelpers);
  }
  return (0, _createClass2.default)(ViewPortHelpers, null, [{
    key: "getViewPort",
    value: function getViewPort(width) {
      var viewPort;
      if (width < 570) {
        viewPort = ViewPort.XS;
      } else if (width > 569 && width < 820) {
        viewPort = ViewPort.SM;
      } else if (width > 819 && width < 1070) {
        viewPort = ViewPort.MD;
      } else if (width > 1069) {
        viewPort = ViewPort.LG;
      } else {
        viewPort = ViewPort.NOT_DEFINED;
      }
      return viewPort;
    }
  }]);
}();
var _default = exports.default = ViewPortHelpers;